const MASQUERADE_COMPANY_ID_KEY = 'masqueradeCompanyId'

/**
 * Read the company id the current user is masquerading as, if any.
 *
 * Superadmin/support/corporate users can masquerade as another company; the id is stored in
 * localStorage under `masqueradeCompanyId`. Returns `null` when not masquerading or when
 * localStorage is unavailable (e.g. SSR, privacy mode).
 */
export function getMasqueradeCompanyId(): string | null {
  try {
    return window?.localStorage?.getItem(MASQUERADE_COMPANY_ID_KEY) || null
  } catch {
    return null
  }
}

/**
 * Build the `company-id` header used to forward masquerade context to the API.
 *
 * Returns `{ 'company-id': <id> }` when masquerading, otherwise an empty object so it can be
 * spread into request headers unconditionally. The API uses this header to scope a request to
 * the masqueraded company instead of the logged-in user's own company.
 */
export function getMasqueradeHeaders(): Record<string, string> {
  const masqueradeCompanyId = getMasqueradeCompanyId()
  return masqueradeCompanyId ? { 'company-id': masqueradeCompanyId } : {}
}
